<template>
  <Modal v-model="editModal" title="手动分配" width="800">
    <Form ref="modalForm" class="form"
          :model="formData" :rules="formRule"
          :label-width="90">
      <Row>
        <Col :span="18">
          <FormItem>
            <label><h3>您选择的名单共计{{formData.totalNum}}个, 当前未分配客户数{{formData.remainder}}个</h3></label>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col :span="12">
          <FormItem label="选择课顾分组">
            <Select v-model="formData.teamType" @on-change="onTeamTypeChange">
              <Option v-for="item in formData.adviserGroupList" :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <ul>
          <li v-for="item in formData.adviserList">
            <Col :span="12">
              <FormItem :label="item.adviserName">
                <Input v-model="item.count" @on-change="onCountChange" placeholder="名单数"/>
              </FormItem>
            </Col>
          </li>
        </ul>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="primary" size="large" @click="editModal=false">取消</Button>
      <Button type="primary" size="large" :loading="insertLoading" @click="confirmAssign">确认分配</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'manualAssignModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      userList: {
        type: Array
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        insertLoading: false,
        params: {
          adviserList: [],
          uids: [],
        },
        formData: {
          totalNum: 0,
          remainder: 0,
          teamType: 0,
          adviserGroupList: this.$constant.adviserGroup,
          adviserList: [],
        },
        formRule: {}
      }
    },
    mounted: function () {
    },
    computed: {
      editModal: {
        get: function () {
          return this.value
        },
        set: function (newValue) {
          this.onClose()
        }
      }
    },
    methods: {
      getAdviserList (teamType) {
        let self = this
        self.$http.get('/adviser/listNoPage?teamType=' + teamType).then(function (res) {
          if (res && res.data) {
            self.formData.adviserList = res.data
          }
        })
      },
      onTeamTypeChange (value) {
        this.getAdviserList(value)
      },
      onCountChange () {
        let self = this
        var sumCount = 0
        var list = self.formData.adviserList
        self.params.adviserList = []
        var index = 0
        for (; index < list.length; index++) {
          var count = parseInt(list[index].count)
          sumCount += count
          if (count > 0) {
            self.params.adviserList.push(list[index])
          }
        }
        self.formData.remainder = self.formData.totalNum - sumCount
      },
      onClose () {
        this.$emit('on-close')
      },
      onSuccess () {
        this.$emit('on-success')
      },
      confirmAssign () {
        let self = this
        self.insertLoading = true
        self.$http.post('/adviser/manualAssignAdviser', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(self.params)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
          self.insertLoading = false
          if (res && res.data > 0) {
            self.$Message.success('操作成功!')
            self.editModal = false
            self.successCallback()
          }
        })
      }
    },
    watch: {
      value (val) {
        if (val) {
          this.getAdviserList(0)
        }
      },
      userList (array) {
        this.params.uids = []
        this.formData.totalNum = array.length
        this.formData.remainder = array.length
        for (var i = 0; i < array.length; i++) {
          this.params.uids.push(array[i].id)
        }
      }
    },
    created: function () {
    }
  }
</script>



// WEBPACK FOOTER //
// ManualAssignModal.vue?ca003a04